import { useStyles } from '@team-griffin/stylr';
import { cssTheme } from '@uds/theme-utils';

export default ({ isMinLg }: { isMinLg: boolean }) =>
  useStyles(
    {
      default: {
        body: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        cta: {
          marginTop: cssTheme.gu3,
        },
      },
    },
    [{ isMinLg }],
  );
